import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';

@Component({
  selector: 'messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {

  constructor(public appService: AppService) { }

  ngOnInit() {
		this.appService.add('',true);
	}

}



// WEBPACK FOOTER //
// ./src/app/messages/messages.component.ts